import { render, staticRenderFns } from "./Featuresp.vue?vue&type=template&id=4bc28383&"
import script from "./Featuresp.vue?vue&type=script&lang=js&"
export * from "./Featuresp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports